$(function () {
	$(document).on('afterClose.fb.lukiSeriesCards', function (event, instance) {
		const trigger = instance.$trigger && instance.$trigger[0];
		const slider = trigger && trigger.closest('.vg-luk-series-card__slider');

		if (!slider) {
			return;
		}

		// Fancybox фокусирует последнюю фотографию и прокручивает контейнер мимо позиции Swiper.
		slider.scrollLeft = 0;
		trigger.focus({preventScroll: true});
	});

	$('[data-collapsible-series-sizes]').each(function () {
		const container = this;
		const sizes = Array.from(container.querySelectorAll('[data-series-size]'));
		const toggle = container.querySelector('[data-series-sizes-toggle]');
		let expanded = false;

		function update() {
			const limit = window.innerWidth < 768 ? 4 : 6;
			const remaining = Math.max(0, sizes.length - limit);

			container.classList.toggle('is-expanded', expanded);
			sizes.forEach(function (size, index) {
				size.hidden = !expanded && index >= limit;
			});

			if (!toggle) {
				return;
			}

			toggle.hidden = remaining === 0;
			toggle.setAttribute('aria-expanded', String(expanded));
			toggle.querySelector('span').textContent = expanded
				? 'Свернуть размеры'
				: 'Показать ещё ' + remaining + ' ' + window.getWordForm(remaining, ['размер', 'размера', 'размеров']);
		}

		if (toggle) {
			toggle.addEventListener('click', function () {
				expanded = !expanded;
				update();
			});
		}

		$(window).on('resize', update);
		update();
	});
});
